import { Coupon,receiveUpdateCoupon,receiveVisitorCoupon } from '@/api/CouponPage';

const state = {
  show_loading : false,
  token: null,
  CustomerInfo : {},
  UserInfo:{},
  Coupon : {list:[]},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
  SHOW_LOADING: (state, {data}) => {
    state['show_loading'] = data;
  },
};
const actions = {
  Coupon({ commit },data) { // 消息接收渠道
    return new Promise((resolve)=>{
      Coupon(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'Coupon',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  receiveUpdateCoupon({ commit },data) { // 消息接收渠道
    return new Promise((resolve)=>{
      receiveUpdateCoupon(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'receiveUpdateCoupon',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  receiveVisitorCoupon({ commit },data) { // 消息接收渠道
    return new Promise((resolve)=>{
      receiveVisitorCoupon(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'receiveVisitorCoupon',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
